import React from "react";
import Footer from "../../Footer";
import { Link } from "react-router-dom";

const D372 = () => {
  return (
    <div className="container" style={{ maxWidth: "70%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">
        You're viewing D372 - Introduction to Systems Thinking
      </h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-regular fa-star"></i>
          <i class="fa-regular fa-star"></i>
          <i class="fa-regular fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 3.88 hrs</h4>
        <hr />
        <div className="card-body">
          <p>
            This class has 3 PAs that are super simple. It's very easy to
            complicate this course, so don’t go down the rabbit hole of trying
            to absorb everything in the study material. You just need to choose
            a case study and do some analysis. As for the study material itself,
            I simply looked up the iceberg diagram, archetype models, etc., on
            Google/YouTube, and it was much easier to understand compared to the
            course material provided. For some reason, I don't like the way
            course material includes links to external books. It's easier for me
            to understand something when it's visually laid out well. There are
            plenty of blogs that explain these concepts on Google. Again, don’t
            overcomplicate the tasks. I had minimal writing in my tasks, just
            straight to the point. I passed all 3 tasks on the first try, with
            no revisions needed.
          </p>
          <br/>
          <p>Also check <i>WestEstablishment719</i> comment on this post:{" "}
          <a href="https://www.reddit.com/r/WGU/comments/12pyi8m/guide_to_d372/" target="_blank" rel="noreferrer">
            https://www.reddit.com/r/WGU/comments/12pyi8m/guide_to_d372/
          </a>
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default D372;
